import { useEffect, useState } from "react";
import { API } from "service/Interceptor";

const STORAGE_KEY = "qreativs.appliedJobIds.v1";
const EVENT = "qreativs-applied-jobs";

let fetched = false;
let inflight = null;

const readIds = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
};

const writeIds = (ids) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    /* quota / private mode */
  }
};

export const markJobApplied = (...jobIds) => {
  const ids = readIds();
  let changed = false;
  jobIds.forEach((id) => {
    if (!id) return;
    const key = String(id);
    if (!ids.has(key)) {
      ids.add(key);
      changed = true;
    }
  });
  if (!changed) return;
  writeIds(ids);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(EVENT));
  }
};

export const isJobMarkedApplied = (jobId) =>
  !!jobId && readIds().has(String(jobId));

const loadAppliedFromApi = () => {
  if (fetched) return Promise.resolve();
  if (inflight) return inflight;
  inflight = API.get("api/job-applications")
    .then((res) => {
      fetched = true;
      const ids = (res?.data?.data?.results || []).flatMap((a) => [
        a?.jobId,
        a?.jobResponseDto?.jobId,
      ]);
      markJobApplied(...ids.filter(Boolean));
    })
    .catch(() => {})
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

export const useAppliedJobIds = () => {
  const [, setTick] = useState(0);

  useEffect(() => {
    const refresh = () => setTick((n) => n + 1);
    window.addEventListener(EVENT, refresh);
    loadAppliedFromApi().then(refresh);
    return () => window.removeEventListener(EVENT, refresh);
  }, []);

  return {
    hasApplied: (jobId) => isJobMarkedApplied(jobId),
  };
};
